import React from "react";
import general from "../../../../../general";

export default function AnnouncementBanner({ announcement, tid }) {
  if (!announcement || announcement.length === 0 || announcement[0].is_read !== false) {
    return null;
  }
  return (
    <div
      className="imc-announcement"
      onClick={() => general.history.push(`/announcement?tid=${tid}&open=true`)}
    >
      <img src="resources/im/laba.png" alt="" />
      <span>{announcement[0].title}</span>
    </div>
  );
}
